import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCrown, FaLock, FaMobileAlt, FaRegUser } from 'react-icons/fa';
import cardApi from './cardApi';
import './CardAuth.css';

function CardLoginPage() {
  const [merchants, setMerchants] = useState([]);
  const [form, setForm] = useState({ merchantId: '', name: '', nationalId: '', phone: '' });
  const [toast, setToast] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    cardApi.getMerchants()
      .then((data) => {
        setMerchants(data);
        setForm((value) => ({ ...value, merchantId: data[0]?.id || '' }));
      })
      .catch(() => setToast('無法載入商戶資料，請稍後再試'));
  }, []);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => setToast(''), 4200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const update = (key) => (event) => setForm((value) => ({ ...value, [key]: event.target.value }));
  const submit = async (event) => {
    event.preventDefault();
    setToast('');
    setLoading(true);
    try {
      await cardApi.customerLogin({ ...form, merchantId: Number(form.merchantId) });
      navigate('/', { replace: true });
    } catch (err) {
      setToast(err.message);
    } finally {
      setLoading(false);
    }
  };
  const selectedMerchant = merchants.find((merchant) => String(merchant.id) === String(form.merchantId));

  return (
    <main className="card-auth-page">
      <div className="card-auth-glow" />
      {toast && <div className="card-toast card-toast--error" role="alert">{toast}</div>}
      <section className="card-auth-card">
        <div className="card-auth-brand"><FaCrown /><span>{selectedMerchant?.name || '會員集點卡'}</span></div>
        <p className="card-auth-kicker">MEMBER REWARDS</p>
        <h1>登入我的集點卡</h1>
        <p className="card-auth-intro">首次登入會自動建立會員資料，請填寫正確資料完成驗證。</p>
        <form onSubmit={submit}>
          <label>選擇商戶<select value={form.merchantId} onChange={update('merchantId')} required>{merchants.map((merchant) => <option key={merchant.id} value={merchant.id}>{merchant.name}</option>)}</select></label>
          <label><FaRegUser /> 姓名<input value={form.name} onChange={update('name')} maxLength="80" required placeholder="請輸入您的姓名" /></label>
          <label><FaLock /> 身分證字號<input value={form.nationalId} onChange={update('nationalId')} maxLength="10" required placeholder="例如：A123456789" style={{ textTransform: 'uppercase' }} /></label>
          <label><FaMobileAlt /> 手機號碼<input value={form.phone} onChange={update('phone')} inputMode="numeric" maxLength="10" required placeholder="09xxxxxxxx" /></label>
          <button className="card-auth-submit" type="submit" disabled={loading}>{loading ? '驗證中…' : '登入並查看集點卡'}</button>
        </form>
        <p className="card-auth-note">登入即表示您同意活動辦法與個人資料使用聲明。</p>
      </section>
    </main>
  );
}

export default CardLoginPage;
